export default "__VITE_ASSET__68728e19__"